let accessToken: string | null = null;

/**
 * @description get access token from memory
 */
export const getToken = (): string | null => {
  return accessToken;
};

/**
 * @description save access token to memory
 * @param token: string
 */
export const saveToken = (token: string): void => {
  accessToken = token;
};

/**
 * @description remove access token from memory
 */
export const destroyToken = (): void => {
  accessToken = null;
};

/**
 * @description remove all app data on logout
 */
export const destroyAllTokens = (): void => {
  accessToken = null;
  window.localStorage.clear();
};

export default { getToken, saveToken, destroyToken, destroyAllTokens };
